module.exports = __webpack_public_path__ + "img/logo-wpp-white.1e4ec7f3.svg";